import { useRouter, type ErrorComponentProps } from "@tanstack/react-router";
import { RotateCw } from "lucide-react";

import { Button } from "~/components/ui/button";
import { errorMessage } from "~/lib/api";

export function DefaultCatchBoundary({ error }: ErrorComponentProps) {
  const router = useRouter();
  console.error(error);

  return (
    <div className="grid min-h-[60vh] flex-1 place-items-center p-6">
      <div
        role="alert"
        className="flex w-full max-w-[560px] flex-col items-center gap-3 border border-status-danger-border bg-status-danger-bg px-6 py-10 text-center text-sm text-fg-body"
      >
        <p className="font-display text-lg font-medium tracking-[-0.02em] text-fg-strong">
          Dit lukt even niet
        </p>
        <p className="max-w-[52ch] text-pretty">{errorMessage(error)}</p>
        <Button size="sm" onClick={() => void router.invalidate()}>
          <RotateCw aria-hidden />
          Probeer opnieuw
        </Button>
      </div>
    </div>
  );
}
